export const epochToDate=(epoch)=>{
    if(epoch==0)
      return null;
    else
      return new Date( new Date(epoch).toUTCString() ).toLocaleString()
}
const isUnixTimestamp=(value)=> {
  return typeof value === "number" && value > 0 && (value % 1 === 0);  // Must be a positive integer
}
export const epochToDateTime=(epoch,mode)=>{
  if(isUnixTimestamp(epoch)){
    const date = new Date(epoch); // Convert from seconds to milliseconds
    if(mode=="date"){
      return date.toLocaleDateString();
    }else if(mode=="datetime"){
      return date.toLocaleString();
    }else{ 
      return date.toLocaleTimeString();
    }
  }else{   
    return epoch;
  }
}


export const TagsReplaceDateLabelsWithDate=(label)=>{
  
    let data=checkMode(label);
    let newContent=TagsTimestampToDate(data.timestamp,data.code);
    return  label.replace(/#.*?#/, `${newContent}`);
}

export const TagsCheckToday=(label)=>{
  let data=checkMode(label);
  // Create Date objects
  const date = new Date(parseInt(data.timestamp));
  const today = new Date();
  // Check if the timestamp is today
  const isToday = date.toDateString() === today.toDateString();
  return isToday;
  
}  
const checkMode=(label)=>{
  let parts =label.split("-");
  let code="";
  let timestamp=null;
  if(parts.length==2){
    let subPart=parts[0].split("#");
    code=subPart[1];
    timestamp=parts[1].replace("#","");
  }
  return {"timestamp":timestamp,"code":code};
}
const TagsTimestampToDate=(timestamp,mode)=>{
  // Create a Date object
  const date = new Date(parseInt(timestamp));
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
  const day = date.getDate().toString().padStart(2, '0');
  // Extract hours and minutes
  let hours = date.getHours();
  const minutes = date.getMinutes();

  // Determine AM/PM
  const ampm = hours >= 12 ? 'pm' : 'am';

  // Convert hours to 12-hour format
  hours = hours % 12 || 12; // Convert 0 to 12 for midnight

  // Format minutes with leading zero if needed
  const formattedMinutes = minutes.toString().padStart(2, '0');

  // Combine into desired format
    
  if(mode=="time"){
    
    const formattedTime = `${hours}:${formattedMinutes} ${ampm}`;
    console.log("1",formattedTime);
    return formattedTime;
  }else{
    const formattedDateTime = `${month}/${day} ${hours}:${formattedMinutes} ${ampm}`;
    console.log("2",formattedDateTime);
    return formattedDateTime;
  }
}
